import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import { AsyncStatus } from 'lib-shared-legacy-types';
import _isEqual from 'lodash/isEqual';
import * as React from 'react';
import { Field } from 'redux-form';

import AutocompleteUserAsync from '../../customDropdown/AutocompleteUserAsync';

type PropsT = {
  fieldLabel: string;
  availableOptions: Array<any>;
  singleChoice: boolean | null;
  required: boolean | null;
  status: AsyncStatus;
  className: string | null;
  elementItem: any;
  getfunction: () => Promise<any>;
  touch: (form: string, field: string) => void;
  stopFormSubmit: ((form: string, errors: any) => void) | null;
  placeholder: string | null;
  hideField: (() => void) | null;
  error: string | null;
  children: any;
} & any;

type StateT = {
  active: boolean;
};

class ListUserEmailOptions extends React.Component<PropsT, StateT> {
  labelRef: React.RefObject<any>;

  constructor(props: PropsT) {
    super(props);
    this.state = {
      active: false,
    };

    this.labelRef = React.createRef();
  }

  onFocusFunction = () => {
    this.setState({ active: true });
  };

  onBlurFunction = (e: any) => {
    this.setState({ active: false });
  };

  componentDidMount() {
    if (this.props.focus && this.labelRef.current) {
      this.labelRef.current.click();
    }
  }

  shouldComponentUpdate(nProps: PropsT, nState) {
    return !_isEqual(this.props, nProps) || !_isEqual(this.state, nState);
  }

  render() {
    const {
      fields,
      fieldLabel,
      meta: { touched, submitFailed, error, valid, form, pristine },
      availableOptions,
      singleChoice,
      required: requiredField,
      touch,
      className,
      placeholder,
      hideField,
    } = this.props;

    const hasError = (touched || submitFailed) && error ? 'has-error' : '';
    const hasSuccess = valid && pristine === false ? 'has-success' : '';

    let isSearchShown = true;
    const selectedOptions: any[] = [];
    let noneFoundMessage = 'None found';
    let formGroupClasses =
      className && typeof className === 'string' ? className : '';

    fields.map((field: any, index: number) => {
      const f = fields.get(index);
      selectedOptions.push(f.user);
    });

    let filteredFields = availableOptions.map((x) =>
      Object.assign(
        x,
        selectedOptions.find((y) => y.id === x.id),
      ),
    );

    if (selectedOptions.length > 0 && singleChoice === true) {
      filteredFields = [];
      isSearchShown = false;
      noneFoundMessage =
        'Only a single choice can be selected. Remove the selected choice if you want another.';
    }

    if (availableOptions === null) {
      filteredFields = [];
    }

    if (this.state.active === true) {
      formGroupClasses += ' focused';
    }

    return (
      <div
        className={`form-group list-user-options-fields user-options-styled ${formGroupClasses} ${hasSuccess} ${hasError}`}
      >
        <label
          ref={this.labelRef}
          className={`control-label ${hasSuccess} ${hasError}`}
          htmlFor="autocomplete-user"
        >
          {fieldLabel ? fieldLabel : 'Actions'}
          {requiredField === true && <span> * </span>}
          {(touched || submitFailed) && error && (
            <span className="validation-text">{error}</span>
          )}
        </label>
        {hideField && (
          <button
            type="button"
            className="btn remove-btn hide-cc-bcc"
            onClick={() => hideField(fieldLabel)}
          >
            <Icon name="close" />
          </button>
        )}

        {fields.map((contactField: any, index: number) => {
          const field = fields.get(index);
          let hasName = false;
          let nameInput: JSX.Element | null = null;

          if (
            field.user.id &&
            field.user.display_name &&
            typeof field.user.display_name === 'string'
          ) {
            hasName = true;
          } else {
            nameInput = (
              <Field
                type="text"
                className="add-name"
                name={`${contactField}.user.display_name`}
                component="input"
                placeholder="Add a name (optional)..."
              />
            );
          }

          const displayname =
            hasName == true
              ? `${field.user.display_name} <${field.user.email}>`
              : field.user.email;

          return (
            <Tooltip content={displayname} key={index}>
              <div className="selected-email field-action">
                <div className="selected-email-label">
                  <span className="label-email">{displayname}</span>
                  {nameInput}
                  <button
                    type="button"
                    className="btn remove-btn"
                    onClick={() => {
                      fields.remove(index);
                    }}
                  >
                    <Icon name="close" />
                  </button>
                </div>
              </div>
            </Tooltip>
          );
        })}
        <AutocompleteUserAsync
          touch={touch}
          stopFormSubmit={this.props.stopFormSubmit}
          isShown={isSearchShown}
          formName={form}
          noneFoundMessage={noneFoundMessage}
          getfunction={this.props.getfunction}
          placeholder={placeholder}
          elements={filteredFields}
          ElementItem={this.props.elementItem}
          onFocusFunction={this.onFocusFunction}
          onBlurFunction={this.onBlurFunction}
          status={this.props.status}
          add={fields.push}
          error={fields.error}
          fields={fields}
          numberOfResults={availableOptions.length}
        />
        {this.props.children}
      </div>
    );
  }
}

export default ListUserEmailOptions;
